import { z } from "zod";
import "../zod-runtime.js";
import { memberRoleSchema, slotSchema } from "../domain/enums.js";
// --- Live-Session-Protokoll (WS, Quickview-Präsenz + Captain-Broadcast) ---
/**
 * Aus welcher Ansicht eine Live-Verbindung kommt. Nur `quickview` folgt der
 * Captain-Steuerung — siehe `docs/adr/0012-live-praesenz-zwei-surfaces.md`.
 */
export const liveSurfaceSchema = z.enum(["quickview", "editor"]);
export const livePresenceEntrySchema = z.object({
    userId: z.string().uuid(),
    email: z.string().email(),
    role: memberRoleSchema,
    /** Ein Member kann Quickview und Editor gleichzeitig offen haben. */
    surfaces: z.array(liveSurfaceSchema).min(1),
});
export const liveStateSchema = z.object({
    tacticId: z.string().min(1).nullable(),
    slotAssignments: z.record(slotSchema, z.string().uuid().nullable()),
    captainOnline: z.boolean(),
});
export const liveAmbiguityGroupSchema = z.object({
    slots: z.array(slotSchema).min(1),
    candidates: z.array(z.object({
        slot: slotSchema,
        memberId: z.string().uuid(),
        email: z.string().email(),
    })),
    /** Nur die betroffenen Slots dieser Gruppe als Keys, kein vollständiger Record. */
    prefill: z.record(z.string(), z.string().uuid().nullable()),
});
export const liveAmbiguitySchema = z.object({
    groups: z.array(liveAmbiguityGroupSchema),
});
export const liveClientMessageSchema = z.discriminatedUnion("type", [
    z.object({ type: z.literal("heartbeat") }),
    z.object({ type: z.literal("select-tactic"), tacticId: z.string().min(1) }),
    z.object({
        type: z.literal("resolve-matching"),
        assignments: z.record(z.string(), z.string().uuid().nullable()),
    }),
]);
export const liveServerMessageSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("presence-update"),
        online: z.array(livePresenceEntrySchema),
    }),
    z.object({ type: z.literal("live-state") }).extend(liveStateSchema.shape),
    z.object({ type: z.literal("ambiguity") }).extend(liveAmbiguitySchema.shape),
    z.object({
        type: z.literal("error"),
        code: z.string(),
        message: z.string(),
    }),
]);
